module.exports = __webpack_public_path__ + "media/images/webpage/shared/spotmap/location__tourspot--active-ec2c474bac9e2bba992b9881c0a7f70b.svg";